// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-dialog {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.privacy-dialog__content {
  line-height: 1.6;
  color: var(--color-text-primary);
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
  min-height: 0;
}

.privacy-dialog__content strong {
  color: var(--color-text-primary);
  font-weight: 600;
}

.privacy-dialog__content br {
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/dialogs/PrivacyDialog.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".privacy-dialog {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.privacy-dialog__content {\n  line-height: 1.6;\n  color: var(--color-text-primary);\n  flex: 1;\n  overflow-y: auto;\n  padding-right: 8px;\n  min-height: 0;\n}\n\n.privacy-dialog__content strong {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.privacy-dialog__content br {\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
